import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons"

export const EllipsisH = (props) => {
  return <FontAwesomeIcon faIcon={faEllipsisH} {...props} />
}
